module.exports = __webpack_public_path__ + "static/coffee_lover-95a7a927045b1dadad06eaf901be2569.svg";